<template>
  <div>
    <header id="blog-header">
      <div class="inner ">
        <slot name="headContent"></slot>
      </div>
    </header>
    <article class="post">
      <div class="inner">
        <p>当前时间：{{ currentTime|time_filter("yyy-mm-dd hh:mm:ss") }}</p>
        <div id="goods">
          选择图片：<input type="file" id="saveimage"><br>
          <button @click="addimages()">添加</button>
          <p>{{image_url}}</p>
        </div>
      </div>
    </article>
  </div>

</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      image_url:null
    }
  },
  methods: {
     addimages () {

        let reqUrl = this.$store.state.baseUrl + '/blog/api/upload-files';
        var data = new FormData();
        var img = document.getElementById('saveimage').files[0];
        data.append('file',img);
        // console.log(reqUrl)
         this.$http.post(reqUrl,data)
          .then((response) => {
            var res = JSON.parse(response.bodyText);
            this.image_url = res.file_url_path;
            console.log(res)
          })
    },
    pad_with_zero(char){
    return char
    }
  },
  computed:{
   currentTime() {
        let date = new Date();
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    }
  },
  filters:{
        time_filter:function(value,args){
            var dt = new Date(value)
            var y = dt.getFullYear().toString().padStart(2,'0')
            var m = (dt.getMonth()+1).toString().padStart(2,'0')
            var d = dt.getDate().toString().padStart(2,'0')
            if(args.toLowerCase() === "yy-mm-dd"){
                return `${y}-${m}-${d}`
            }else{
                var hh = dt.getHours().toString().padStart(2,'0')
                var mm = dt.getMinutes().toString().padStart(2,'0')
                var ss = dt.getSeconds().toString().padStart(2,'0');
                return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
            }
        }
    },
  created () {
  }
}
</script>

<style scoped>

</style>
